import { Typography, styled } from '@mui/material';

const StyledTableRowLabel = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium
}));

export default StyledTableRowLabel;
